/* eslint-disable import/first */
/**
 * importing the global styles
 */
import "./assets/styles/styles.scss";

/**
 *  Adding prefix 'oui-' to the bootstrap classes to be used in Reactstrap
 */
import Util from "reactstrap/lib/utils";
import classNames from "./lib/styles";

/* istanbul ignore next */

if (process.env.NODE_ENV !== "test") {
  const prefix = "oui-";
  const classNameMappings = classNames.reduce((mapper, cls) => {
    mapper[cls] = prefix + cls;
    return mapper;
  }, {});
  Util.setGlobalCssModule(classNameMappings);
}

/**
 * exporting all the components we needs to expose under Orion
 */
import Accordion from "./components/accordion/accordion";
import ActionButtons from "./components/actionButtons/actionButtons";
import Alert from "./components/alert/alert";
import AutoSuggest from "./components/autoSuggest/autoSuggest";
import Badge from "./components/badge/badge";
import Bouncer from "./components/bouncer/bouncer";
import Breadcrumb from "./components/breadcrumb/breadcrumb";
import Button from "./components/button/button";
import ButtonGroup from "./components/buttonGroup/buttonGroup";
import Card from "./components/card/card";
import Col from "./components/col/col";
import Collapse from "./components/collapse/collapse";
import ConfirmationModal from "./components/modal/confirmationModal";
import Container from "./components/container/container";
import DatePicker from "./components/datePicker/datePicker";
import DataGrid from "./components/dataGrid";
import Dropdown from "./components/dropdown/dropdown";
import FilterButton from "./components/filterButton/filterButton";
import Form from "./components/form/form";
import FormGroup from "./components/formGroup/formGroup";
import GlobalFooter from "./components/globalFooter/globalFooter";
import Headerbar from "./components/headerbar/headerbar";
import Heading from "./components/heading/heading";
import Icon from "./components/icon/icon";
import InformationModal from "./components/modal/informationModal";
import Input from "./components/input/input";
import InputFeedback from "./components/inputFeedback/inputFeedback";
import InputGroup from "./components/inputGroup/inputGroup";
import Label from "./components/label/label";
import LabelValue from "./components/labelValue/labelValue";
import Loader from "./components/loader/loader";
import MessageBox from "./components/messageBox/messageBox";
import Modal from "./components/modal/modal";
import OrionProvider from "./components/orionContext/orionContext";
import Page from "./components/page/page";
import Pagination from "./components/pagination/pagination";
// import PhoneInput from "./components/phoneInput/phoneInput";
import Popover from "./components/popover/popover";
import PoweredByDruva from "./components/poweredByDruva/poweredByDruva";
import Progress from "./components/progress/progress";
import Row from "./components/row/row";
import Select from "./components/select/select";
import Sidebar from "./components/sidebar/sidebar";
import SideNav from "./components/sideNav/sideNav";
import Slider from "./components/slider/slider";
import Spinner from "./components/spinner/spinner";
import Tab from "./components/tab/tab";
import Table from "./components/table/table";
import Tag from "./components/tag/tag";
import TagSelect from "./components/tagSelect/tagSelect";
import TimePicker from "./components/timePicker/timePicker";
import Toast from "./components/toast/toast";
import ToggleButton from "./components/toggleButton/toggleButton";
import Tooltip from "./components/tooltip/tooltip";
import Tree from "./components/tree/tree";
import Wizard from "./components/wizard/wizard";
import GlobalSidebarTemplate from "./components/templates/globalSidebarTemplate/globalSidebarTemplate";
import GlobalHeaderTemplate from "./components/templates/globalHeaderTemplate/globalHeaderTemplate";
/* import template placeholder */

export {
  Accordion,
  ActionButtons,
  Alert,
  AutoSuggest,
  Badge,
  Bouncer,
  Breadcrumb,
  Button,
  ButtonGroup,
  Card,
  Col,
  Collapse,
  ConfirmationModal,
  Container,
  DatePicker,
  DataGrid,
  Dropdown,
  FilterButton,
  Form,
  FormGroup,
  GlobalFooter,
  Headerbar,
  Heading,
  Icon,
  InformationModal,
  Input,
  InputFeedback,
  InputGroup,
  Label,
  LabelValue,
  Loader,
  MessageBox,
  Modal,
  OrionProvider,
  Page,
  Pagination,
  // PhoneInput,
  Popover,
  PoweredByDruva,
  Progress,
  Row,
  Select,
  Sidebar,
  SideNav,
  Slider,
  Spinner,
  Tab,
  Table,
  Tag,
  TagSelect,
  TimePicker,
  Toast,
  ToggleButton,
  Tooltip,
  Tree,
  Wizard,
  GlobalSidebarTemplate,
  GlobalHeaderTemplate
  /* export template placeholder */
};
